import { defineMessages } from 'react-intl-next';

export default defineMessages({
	loadingStateAccessibleName: {
		id: 'navigation-global-side-navigation.object-list-flyout.loading-state.accessible-name',
		defaultMessage: 'Content is loading',
		description: 'Accessible name for the loading state in the object list flyout',
	},
});
